import { defineMessages } from 'react-intl';

import { CASFilters, TransformedContact } from './types';
import { SortableColumn, SortConfig, SortDirection } from '../../../../utils/list-filters/list-filter-types';

export const CAS_MESSAGES = defineMessages({
  contact: {
    id: 'predict.contact',
    defaultMessage: 'Contact'
  }
});

// Sortable column definitions
export const CAS_SORTABLE_COLUMNS: SortableColumn[] = [
  {
    key: 'name',
    labelStyle: 'alpha',
    columnNameId: CAS_MESSAGES.contact.id!,
    columnNameDefaultMessage: CAS_MESSAGES.contact.defaultMessage as string
  },
  {
    key: 'total_amount_due',
    labelStyle: 'numeric',
    columnNameId: 'predict.column_total_due',
    columnNameDefaultMessage: 'Total due'
  },
  {
    key: 'total_amount_overdue',
    labelStyle: 'numeric',
    columnNameId: 'predict.column_total_overdue',
    columnNameDefaultMessage: 'Total overdue'
  },
  {
    key: 'total_amount_invoiced',
    labelStyle: 'numeric',
    columnNameId: 'predict.column_total_invoiced',
    columnNameDefaultMessage: 'Total invoiced'
  },
  {
    key: 'invoices_due',
    labelStyle: 'numeric',
    columnNameId: 'predict.column_invoices_due',
    columnNameDefaultMessage: 'Invoices due'
  },
  {
    key: 'average_sale',
    labelStyle: 'numeric',
    columnNameId: 'predict.column_average_sale',
    columnNameDefaultMessage: 'Average sale'
  },
  {
    key: 'average_days_to_pay',
    labelStyle: 'numeric',
    columnNameId: 'predict.days_to_pay',
    columnNameDefaultMessage: 'Days to pay'
  },
  {
    key: 'dependence',
    labelStyle: 'numeric',
    columnNameId: 'predict.column_dependence',
    columnNameDefaultMessage: 'Dependence'
  },
  {
    key: 'last_activity',
    labelStyle: 'date',
    columnNameId: 'predict.column_last_activity',
    columnNameDefaultMessage: 'Last activity'
  }
];

// Sort comparators
export const COMPARATORS: Record<string, (a: TransformedContact, b: TransformedContact) => number> = {
  name: (a, b) => a.name.localeCompare(b.name),
  total_amount_due: (a, b) => a.total_amount_due - b.total_amount_due,
  total_amount_overdue: (a, b) => a.total_amount_overdue - b.total_amount_overdue,
  total_amount_invoiced: (a, b) => a.total_amount_invoiced - b.total_amount_invoiced,
  invoices_due: (a, b) => a.unpaid_invoices - b.unpaid_invoices,
  average_sale: (a, b) => a.average_sale - b.average_sale,
  average_days_to_pay: (a, b) => a.average_days_to_pay - b.average_days_to_pay,
  dependence: (a, b) => a.dependence - b.dependence,
  last_activity: (a, b) => a.last_activity.getTime() - b.last_activity.getTime()
};

// Default filter state
export const DEFAULT_FILTERS: CASFilters = {
  contacts: { selectedValues: [] },
  totalDue: {},
  totalOverdue: {},
  totalInvoiced: {},
  invoicesDue: {},
  averageSale: {},
  daysToPay: {},
  dependence: {},
  lastActivity: {}
};

export const DEFAULT_SORT: SortConfig = {
  column: 'total_amount_due',
  direction: SortDirection.DESC
};

export const DEFAULT_PERIOD = 'last-24-months';

export const LOCAL_STORAGE_KEY = 'customers-suppliers-filter-v2';
